module.exports = __webpack_public_path__ + "static/media/logo-text.df331d4b.png";